import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`📥 STEP: Create Your Slack App`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Create a Slack app, by going to `}<a parentName="p" {...{
            "href": "https://api.slack.com/apps"
          }}>{`https://api.slack.com/apps`}</a>{` and clicking `}<inlineCode parentName="p">{`Create New App`}</inlineCode>{`. `}</p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack001.png",
          "alt": "slack7"
        }}></img>
      </li>
    </ol>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">
        <p parentName="li">{`Select `}<inlineCode parentName="p">{`From an app manifest`}</inlineCode></p>
        <img parentName="li" {...{
          "src": "./../images/slack/slack002.png",
          "alt": "slack7"
        }}></img>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Select the appropriate workspace that you have created before and click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Copy and paste the content of this file `}<a href="https://raw.githubusercontent.com/niklaushirt/ibm-aiops-deployer/main/doc/slack/slack-app-manifest.yaml" target="_blank">{`slack-app-manifest.yaml`}</a>{` .`}</p>
      </li>
    </ol>
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Adapt the Name and Display Name to your likings`}</li>
    </ol>
    <pre><code parentName="pre" {...{}}>{`> Don't bother with the URLs just yet, we will adapt them as needed.
`}</code></pre>
    <ol {...{
      "start": 5
    }}>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Next`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click `}<inlineCode parentName="p">{`Create`}</inlineCode></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Scroll down to Display Information and name your CP4AIOPS app`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You can add an icon to the app`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Click save changes`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`In the `}<inlineCode parentName="p">{`Basic Information`}</inlineCode>{` menu click on `}<inlineCode parentName="p">{`Install to Workspace`}</inlineCode>{` then click `}<inlineCode parentName="p">{`Allow`}</inlineCode></p>
      </li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      